module.exports = __webpack_public_path__ + "media/app/assets/specializations/druid/restoration-5b698930c85335401de15afe3f4a5efe.png";